import { gql } from '@apollo/client'
import { reviewFragment } from 'modules/reviews/fragments.graphql'

export const userReviewsQuery = gql`
  ${reviewFragment}
  query UserReviews($username: String!, $take: Int, $skip: Int, $exclude: [ID!]) {
    user(username: $username) {
      id
      reviews(take: $take, skip: $skip, exclude: $exclude) {
        items {
          ...ReviewFields
          brand {
            id
            slug
            title
            primaryImageUrl
            primaryImageFullPath
          }
        }
        nextSkip
        hasMore
        total
      }
    }
  }
`
